export default __webpack_public_path__ + "static/media/lbp.4954bb20.svg";